export default () => {
    let toggle = false
    window.addEventListener('load', function () {
        setTimeout(() => {
            loadEnd()
            toggle = true
        }, 250);
    });
    setTimeout(() => {
        if(!toggle) loadEnd()
        toggle = true
    }, 5000);

    function loadEnd() {
        document.body.removeAttribute('id', 'preload');
        const loaderItem = document.getElementById('loader')
        loaderItem.classList.add('loadOp');
        setTimeout(() => {
            if(loaderItem)
                loaderItem.classList.add('loadend');
        }, 1000);
    }
}